import { connect } from 'react-redux';
import { flow, defaultTo, get, pick, getOr } from 'lodash/fp';
import ItemDescription from './ItemDescription';
import { getAttributeValue, getAttributeValueOr } from '../../helpers/getAttributeValue';

const getItemDetails = itemProduct => (
  itemProduct && {
    color: getAttributeValueOr('Not selected', 'color', itemProduct),
    windowName: getAttributeValue('window name', itemProduct),
    brand: get('brand', itemProduct),
    productName: get('productName', itemProduct),
  }
);

const mapStateToProps = ({ estimateBuilder }, { itemId }) => {
  const item = get(`entities.items.byId.${itemId}`, estimateBuilder);

  const label = get('label', item);
  const containerId = get('containerId', item);

  const itemProduct = get('itemProduct', item);
  const itemDetails = flow(
    getItemDetails,
    defaultTo({}),
  )(itemProduct);

  return {
    itemName: flow(
      get('windowName'),
      defaultTo(label),
    )(itemDetails),
    containerName: get(`entities.containers.byId.${containerId}.name`, estimateBuilder),
    mainImageUrl: getOr('', 'mainImageUrl', itemProduct),
    ...pick([
      'color',
      'brand',
      'productName',
    ], itemDetails),
  };
};

export default connect(mapStateToProps)(ItemDescription);
